import React from 'react';
import axios from 'axios';
import { ExternalLink, CheckCircle } from 'lucide-react';

const KIND_LABEL = {
  gim_toli: 'Ce Gim Toli est sponsorisé par',
  podcast: 'Ce podcast est sponsorisé par',
  short_film: 'Ce film court est sponsorisé par',
  video: 'Cette vidéo est sponsorisée par',
};

/**
 * Sponsorship mention rendered on Gim Toli / Podcast / Short Film cards.
 *
 * On click of the sponsor link, we ping POST /api/monetization/click/{request_id}
 * (fire-and-forget) so both creator and PRO can track CTR. We do NOT block the
 * navigation on the click POST — it's best-effort using sendBeacon when possible.
 */
export default function SponsorshipBadge({ sponsorship, contentKind = 'gim_toli', compact = false }) {
  if (!sponsorship?.sponsor_name) return null;
  const url = sponsorship.sponsor_website || '';
  const label = KIND_LABEL[contentKind] || 'Sponsorisé par';

  const handleClick = (e) => {
    if (!sponsorship.request_id) return;
    try {
      const base = process.env.REACT_APP_BACKEND_URL || '';
      const endpoint = `${base}/api/monetization/click/${sponsorship.request_id}`;
      if (navigator.sendBeacon) {
        navigator.sendBeacon(endpoint);
      } else {
        // Fire-and-forget axios call so we don't block navigation
        axios.post(endpoint).catch(() => {});
      }
    } catch (_e) { /* ignore */ }
  };

  return (
    <div
      className={`flex items-center gap-2 ${compact ? 'text-xs px-2.5 py-1' : 'text-sm px-3 py-1.5'} mb-3 rounded-full bg-gradient-to-r from-emerald-500/15 to-cyan-500/15 border border-emerald-500/30 text-emerald-100 max-w-fit`}
      data-testid="sponsorship-badge"
    >
      <CheckCircle className={`${compact ? 'w-3 h-3' : 'w-3.5 h-3.5'} text-emerald-400 flex-shrink-0`} />
      <span className="text-gray-300">{label}</span>
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClick}
          className="font-semibold hover:underline inline-flex items-center gap-1"
          data-testid="sponsorship-link"
        >
          {sponsorship.sponsor_name}
          <ExternalLink className={compact ? 'w-2.5 h-2.5' : 'w-3 h-3'} />
        </a>
      ) : (
        <span className="font-semibold">{sponsorship.sponsor_name}</span>
      )}
    </div>
  );
}
